module.exports = {"publisher":"Vydavatel: ","certificate":"Obdržený certifikát","noData":"Subjekt není držitelem žádného certifikátu"}